import { Language } from '@app/translate/models/language';
import { Translation } from '@app/translate/models/translation';
import { TranslationMap } from '@app/translate/models/translation-map';
import { loggerFor } from '@app/utils/logger';
import * as log from 'loglevel';

export class Translations {
  public itemMap: TranslationMap = {};
  public languages: Language[] = [];
  public languageKeys: string[] = [];
  private logger: log.Logger = loggerFor('Translations');

  get items(): Translation[] {
    return Object.values(this.itemMap);
  }

  constructor(itemMap: TranslationMap = {}, keys: string[] = [], languages: Language[] = []) {
    this.itemMap = itemMap;
    this.languages = languages;
    this.languageKeys = keys;
  }

  public getOverrides(languageKey: string): Language {
    const language: Language = {};

    for (const item of this.items) {
      if (item.overrides[languageKey] != null) {
        language[item.key] = item.overrides[languageKey];
      }
    }

    return language;
  }

  public getLanguage(languageKey: string) {
    const index = this.languageKeys.findIndex((_) => _ === languageKey);

    return this.languages[index];
  }

  public item(key: string) {
    if (this.itemMap[key] === undefined) {
      this.logger.warn(`No translation for key ${key} found!`);

      this.updateTranslation(new Translation(key));
    }

    return this.itemMap[key];
  }

  public updateTranslation(translation: Translation) {
    this.itemMap[translation.key] = translation;
  }
}

export const EmptyTranslations = new Translations();
